import React from "react";
import Title from "../../UI/organisms/Title/Title";
import { CallToOfferType } from "./Types";

import "./CallToOffer.scss";

const CallToOffer = () => {
  const publicUrl = process.env.PUBLIC_URL;
  const data: CallToOfferType[] = [
    {
      id: "black-friday-vitalicio",
      title: {
        intro:
          "<strong>ESPECIAL DE BLACK FRIDAY:</strong><br/>De 40% por 70% OFF nos 7 cursos de nefrologia da Val!",
        title: "BLACK FRIDAY 2026",
      },
      flag: "SOMENTE ATÉ DIA 30/11",
      link: "https://valquiriaarenas.com/black-vitalicia-2026",
    },
    {
      id: "empowernefro-hdf",
      title: {
        intro:
          "2023 e 2024 foi muito bom... 2025 foi espetacular... 2026 foi inesquecível e 2027 será Fantástico!",
        title: "EMPOWERNEFRO 2027",
      },
      flag: "BLACK 2026 - 50% OFF",
      link: "/curso/empowernefro-hdf",
    },
    // {
    //   id: "pos-graduacao",
    //   title: {
    //     intro:
    //       "Escreva seu Futuro na Nefrologia e Torne-se um Especialista de Alto Nível",
    //     title: "Pós-graduação",
    //   },
    //   flag: "BLACK 2026 - 40% OFF",
    //   link: "/curso/pos-graduacao",
    // },
  ];

  return (
    <div className="all-call-to-offer">
      {data.map((item) => (
        <a href={item.link} className="call-to-offer" key={item.id}>
          <div
            className="call-to-offer__container"
            style={{
              backgroundImage: `url(${publicUrl}/img/parts/row-quantity.svg)`,
            }}
          >
            {item.flag && (
              <div className="call-to-offer__container--flag">{item.flag}</div>
            )}
            <Title info={item.title} tag="h2" />
            <div className="call-to-offer__container--button">
              EU QUERO <span>&#10148;</span>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default CallToOffer;
